import { useEffect, useState, useCallback } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, Loader2, XCircle, BookHeart } from "lucide-react";
import { Button } from "../components/ui/button";

const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | timeout | error
  const [attempts, setAttempts] = useState(0);

  const poll = useCallback(async () => {
    if (!sessionId) { setState("error"); return; }
    try {
      const { data } = await api.get(`/payments/status/${sessionId}`);
      if (data.payment_status === "paid") { setState("paid"); return; }
      if (attempts >= 15) { setState("timeout"); return; }
      setTimeout(() => setAttempts((a) => a + 1), 2000);
    } catch {
      if (attempts >= 15) { setState("error"); return; }
      setTimeout(() => setAttempts((a) => a + 1), 2000);
    }
  }, [sessionId, attempts]);

  useEffect(() => { poll(); }, [poll]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="text-center bg-white rounded-3xl border border-border p-12 max-w-md" data-testid="payment-success">
        <div className="flex items-center justify-center gap-2 mb-6">
          <BookHeart className="w-6 h-6 text-primary" /><span className="font-serif text-xl">Eterna</span>
        </div>
        {state === "checking" && (<><Loader2 className="w-12 h-12 text-primary mx-auto mb-4 animate-spin" /><h1 className="font-serif text-2xl mb-2">Confermiamo il pagamento…</h1><p className="text-muted-foreground">Attendere qualche istante.</p></>)}
        {state === "paid" && (<><CheckCircle2 className="w-12 h-12 text-[#81B29A] mx-auto mb-4" /><h1 className="font-serif text-2xl mb-2">Grazie! Piano attivato</h1><p className="text-muted-foreground mb-6">Il tuo nuovo spazio è ora disponibile.</p><Button onClick={() => navigate("/ricordi")} className="rounded-full bg-primary hover:bg-[#c9694f] text-white" data-testid="success-continue">Torna al mio libro</Button></>)}
        {(state === "timeout" || state === "error") && (<><XCircle className="w-12 h-12 text-muted-foreground mx-auto mb-4" /><h1 className="font-serif text-2xl mb-2">Verifica in corso</h1><p className="text-muted-foreground mb-6">Il pagamento potrebbe richiedere qualche minuto. Controlla di nuovo tra poco.</p><Button onClick={() => navigate("/piani")} variant="outline" className="rounded-full border-border" data-testid="success-back">Ai piani</Button></>)}
      </div>
    </div>
  );
};

export default PaymentSuccess;
